import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
});

const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem('refreshToken');
  const res = await axios.post(`${BASE_URL}/refresh`, { refreshToken });
  const { accessToken, refreshToken: newRefresh } = res.data;
  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('refreshToken', newRefresh);
  return accessToken;
};

const apiCall = async (fn) => {
  try {
    return await fn(getHeaders());
  } catch (err) {
    if (err.response?.status === 401) {
      const newToken = await refreshAccessToken();
      return await fn({ Authorization: `Bearer ${newToken}` });
    }
    throw err;
  }
};

export { BASE_URL, apiCall };
